import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Space } from 'antd';
import * as Component from 'components';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { genreApiService } from 'service/api/genreApiService';
import { GenreInterface } from 'type/genreType';

const Genre: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams({
    page: '1',
    page_size: '100',
    order_by: 'id',
    order_direction: 'desc',
  });
  const navigate = useNavigate();

  const dataFetch = async (
    params: URLSearchParams
  ): Promise<{ data: GenreInterface[]; count: number }> => {
    const response = await genreApiService.fetch(params);
    return {
      data: response.results,
      count: response.count,
    };
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (_: string, record: GenreInterface) => (
        <a href={`/genre/edit/${record.id}`}>{record.name}</a>
      ),
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'ACTIONS',
      key: 'actions',
      dataIndex: 'actions',
      render: (_text: string, record: GenreInterface) => (
        <Space>
          <Button
            icon={<SettingOutlined />}
            onClick={() => navigate(`/genre/edit/${record.id || 0}`)}
            className="action-btn"
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => message.info('You do not have permission')}
            className="action-btn delete-btn"
          />
        </Space>
      ),
    },
  ];

  return (
    <Component.BasePageComponent>
      <Component.TableComponent
        name="genre"
        columns={columns}
        searchParams={searchParams}
        dataFetch={dataFetch}
        setSearchParams={setSearchParams}
        actions={
          {
            // onAddClick: () => navigate('/genre/add'),
          }
        }
      />
    </Component.BasePageComponent>
  );
};

export default Genre;
